import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './app/Header';
import { Footer } from './app/Footer';
import { CartDrawer } from './components/CartDrawer';
import { FournisseurBoutique } from './state/boutique';
import { FournisseurToasts } from './ui/kit';
import { RetourEnHaut } from './ui/RetourEnHaut';
import { Accueil } from './pages/Home';
import { Catalogue } from './pages/Catalogue';
import { ProduitDetail } from './pages/Product';
import { Panier } from './pages/Cart';
import { Commande } from './pages/Checkout';
import { Compte } from './pages/Account';
import { Boutiques } from './pages/Stores';
import { Maison } from './pages/Story';
import { Livraison } from './pages/Delivery';
import { Introuvable } from './pages/NotFound';
import { Mentions } from './pages/Legal';

/**
 * COQUILLE DE LA VITRINE
 * Le châssis (en-tête, pied, tiroir panier, toasts) est monté une fois ; les pages
 * ne s'occupent que d'elles-mêmes. Le défilement revient en haut à chaque
 * changement de route — sans quoi on arrive au milieu d'une fiche produit.
 */
function Remonter() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior }); }, [pathname]);
  return null;
}

export function App() {
  return (
    <FournisseurBoutique>
      <FournisseurToasts>
        <a href="#contenu" className="skip">Aller au contenu principal</a>
        <Remonter />
        <Header />
        <Routes>
          <Route path="/" element={<Accueil />} />

          {/* Catalogue : /boutique puis /boutique/<famille> */}
          <Route path="/boutique" element={<Catalogue />} />
          <Route path="/boutique/:famille" element={<Catalogue />} />

          {/* Fiche produit */}
          <Route path="/produit/:slug" element={<ProduitDetail />} />

          {/* Tunnel */}
          <Route path="/panier" element={<Panier />} />
          <Route path="/commande" element={<Commande />} />

          {/* Espace client — le détail d'une commande a son adresse, pour le SMS */}
          <Route path="/mon-compte" element={<Compte />} />
          <Route path="/mon-compte/commandes/:numero" element={<Compte />} />
          <Route path="/mon-compte/commandes" element={<Compte />} />

          {/* Pages de service */}
          <Route path="/nos-boutiques" element={<Boutiques />} />
          <Route path="/notre-maison" element={<Maison />} />
          <Route path="/livraison-et-retrait" element={<Livraison />} />
          <Route path="/mentions-legales" element={<Mentions />} />

          <Route path="*" element={<Introuvable />} />
        </Routes>
        <Footer />
        <RetourEnHaut />
        <CartDrawer />
      </FournisseurToasts>
    </FournisseurBoutique>
  );
}
